
export const gameActions = {
  game: 'game',
  period: 'period',
  shootoutkick: 'shootoutkick',
  goal: 'goal',
  substitution: 'substitution',
  cardyellow: 'cardyellow',
  cardred: 'cardred',
  penaltykick: 'penaltykick',
  shootoutsave: 'shootoutsave',
  varreview: 'varreview',
  kickoffteam: 'kickoffteam',
  save: 'save'
}

export const actionsSubtypes = {
  own: 'own',
  var_overturned: 'var_overturned',
  awarded: 'awarded',
  secondyellow: 'secondyellow'
}

export const gamePhases = {
  postMatch: 'POSTMATCH',
  halfTime: 'HALFTIME',
  regular: 'REGULAR',
  penaltyshootout: 'PENALTYSHOOTOUT',
  extratime: 'EXTRATIME',
  overtime: 'OVERTIME',
  preMatch: 'PREMATCH',
  interrupted: 'INTERRUPTED'
}

export const directions = {
  left: 'left',
  right: 'right'
}

export const gamePhaseActions = [gameActions.game, gameActions.period]


export const UCL = '19'
export const EPL = '36'
export const DFL = '40'
export const LALIGA = '53'
export const MLS = '190'
export const NHL = '610'
export const UEL = '2072'

export const homeFirstCompetitions = [
  UCL,
  EPL,
  DFL,
  LALIGA,
  NHL,
  UEL
]

export const europeanCompetitionsWithDraws = [
  UCL, EPL, DFL, LALIGA, UEL, DFL
]

export const americanCompetitionsWithDraws = [
  NHL, MLS
]

export const inStadiumExperienceSlides = {
  passing: 'passing',
  rushing: 'rushing',
  receiving: 'receiving',
  gameTracker: 'gameTracker',
  scheduleTable: 'scheduleTable'
}

export const matchStatusOptions = {
  preMatch: 'PreMatch',
  postMatch: 'PostMatch',
  inPlay: 'InPlay'
}
